import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import GatewaySetting from "pages/management/setting/iot/gateway";
import GatewayViewSetting from "pages/management/setting/iot/gateway-view";

export default function MonitoringSettingGatewayRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <GatewaySetting /> }/>
                
                <Route path=":id" element={ <GatewayViewSetting /> }/>
                
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}